<div class="fitness-calendar" [ngClass]="CalendarFullScreen ? 'h-full' : '' ">
  <ejs-schedule #scheduleObj
    width="100%"
    height="100%"
    cssClass="md-custom-header"
    [selectedDate]="currentDate"
    [currentView]="currentView"
    [group]="group"
    [rowAutoHeight]="true"
    [eventSettings]="eventSettings"
    (created)="onScheduleCreated($event)"
    (eventClick)="onEventClick($event)"
    (cellClick)="onCellClick($event)"
    (actionBegin)="onActionBegin($event)"
    (actionComplete)="onActionComplete($event)"
    (eventRendered)="onEventRendered($event)"
    aria-label="calendar-component">

    <e-resources>
      <!-- Define resources based on view (Trainer/Studio) -->
      <e-resource *ngIf="isTrainerView"
        field='ResourceId'
        title='Trainer'
        name='Trainers'
        [dataSource]='trainerResources'
        textField='name'
        idField='ResourceId'
        colorField='color'
        [allowMultiple]='true'>
      </e-resource>
      <e-resource *ngIf="isStudioView"
        field='ResourceId'
        title='Studio'
        name='Studios'
        [dataSource]='studioResource'
        textField='name'
        idField='ResourceId'
        colorField='color'
        [allowMultiple]='true'>
      </e-resource>
    </e-resources>

    <!-- Resource Header Template -->
    <ng-template #resourceHeaderTemplate let-data>
      <div class="md-resource-details-cont flex align-items-center" [attr.aria-label]="'resource-details-' + data.resourceData?.name">
        <!-- Use this when Image not Present -->
        <div *ngIf="isTrainerView">
          <p-avatar *ngIf="data.resourceData?.img; else noContactPic1" [image]="data.resourceData?.img" class="mr-2" [attr.aria-label]="'resource-avatar-' + data.resourceData?.name"></p-avatar>
          <ng-template #noContactPic1>
            <p-avatar styleClass="text-sm w-2rem h-2rem mr-2" label="{{data.resourceData?.name | titlecase | shortName}}" [attr.aria-label]="'resource-avatar-' + data.resourceData?.name"></p-avatar>
          </ng-template>
        </div>
        <div class="md-resource-details-name -mt-1 text-xs">{{data.resourceData?.name }}</div>
      </div>
    </ng-template>

    <e-views>
      <!-- Use all standard views with their proper configuration -->
      <e-view option="Day" [timeScale]="timeScaleOption"></e-view>
      <e-view option="Week" [timeScale]="timeScaleOption"></e-view>
      <e-view option="WorkWeek" [timeScale]="timeScaleOption"></e-view>
      <e-view option="Month" [showWeekend]="true" [showWeekNumber]="true" [maxEventsPerRow]="1"></e-view>
      <e-view option="Agenda" [allowVirtualScrolling]="true"></e-view>
      <!-- Trainer and Studio views use TimelineDay with different display names -->
      <e-view option="TimelineDay" [timeScale]="timeScaleOption" displayName="Trainer View" [resourceHeaderTemplate]="resourceHeaderTemplate" [group]="group"></e-view>
      <e-view option="TimelineDay" [timeScale]="timeScaleOption" displayName="Studio View" [resourceHeaderTemplate]="resourceHeaderTemplate" [group]="group"></e-view>
    </e-views>

    <!-- Event Template -->
    <ng-template #eventSettingsTemplate let-data>
      <div *ngIf="data.Type === 'appointment'"
          [ngClass]="data.CssClass"
          class="flex align-items-center p-1 line-height-1 overflow-hidden"
          [attr.aria-label]="'appointment-event-' + data.Guid">
          <ng-container [ngTemplateOutlet]="appointmentViewInWeek"
            [ngTemplateOutletContext]="{data: getAppointmentFromData(data), event: data}"></ng-container>
      </div>
      <div *ngIf="data.Type === 'class'"
          [ngClass]="data.CssClass"
          class="p-1 line-height-1 overflow-hidden"
          [attr.aria-label]="'class-event-' + data.Guid">
          <ng-container [ngTemplateOutlet]="classViewInWeek"
            [ngTemplateOutletContext]="{data: getClassFromData(data), event: data}"></ng-container>
      </div>
    </ng-template>

    <!-- Agenda Template -->
    <ng-template #agendaTemplate let-data>
      <div class="md-full-event" [attr.aria-label]="'agenda-day-' + data.date">
        <div *ngFor="let event of data.events">
          <div class="p-2 line-height-2 text-900 overflow-hidden flex align-items-center justify-content-between cursor-pointer"
              (click)="openClassAppointmentPopup(event)"
              [ngClass]="event.CssClass" [attr.aria-label]="'agenda-event-' + event.Guid">
            <ng-container [ngTemplateOutlet]="event.Type === 'class' ? classDetails : appointmentDetails"
              [ngTemplateOutletContext]="{data: event.Type === 'class' ? getClassDetailsForAgenda(event) : getAppointmentFromData(event), event: event}"></ng-container>
          </div>
          <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none m-0">
        </div>
      </div>
      <hr class="border-white border-top-1 border-bottom-none border-left-none border-right-none my-0">
    </ng-template>

    <!-- Shared template parts -->
    <ng-template #classDetails let-classObj='data' let-event="event">
      <div class="w-7" *ngIf="classObj" [ngClass]="classObj.status === 'Cancelled'? 'line-through':''" aria-label="class-details">
        <div class="text-xs flex align-items-center"><strong>{{classObj.type_name_primary_language}}</strong>
          <i *ngIf="classObj.is_virtual" class="fa fa-video ml-2 text-900" aria-label="virtual-class-indicator"></i>
        </div>
        <div class="text-xxs">
          <strong>{{'SCHEDULE.CALENDAR.RESERVED' | translate }} {{classObj.total_booking}} / {{classObj.max_capacity}}</strong>     <strong>{{'SCHEDULE.CALENDAR.WAITLIST' | translate }} {{classObj.total_waitlist_booking}} / {{classObj.max_waitlist}}</strong>
          <br>
          <strong>{{'SCHEDULE.CALENDAR.TRAINER' | translate }}: </strong> {{classObj.coach_name}}
          <br>
          <strong>{{'SCHEDULE.CALENDAR.DURATION' | translate }}: </strong>{{classObj.class_duration}} {{'SCHEDULE.CALENDAR.MIN' | translate }} ({{ event.StartTime | date: 'shortTime'}} {{'SCHEDULE.CALENDAR.TO' | translate }} {{ event.EndTime | date: 'shortTime' }})
        </div>
      </div>
      <div class="w-5 flex align-items-center justify-content-end overflow-hidden" *ngIf="classObj && classObj.class_clients" aria-label="class-participants">
        <ng-container *ngFor="let client of classObj.class_clients | slice:0:3;">
          <p-avatar *ngIf="client.image; else noContactPicAgenda" [image]="client.image" styleClass="mr-2 w-2rem h-2rem" shape="circle" [attr.aria-label]="'participant-avatar-' + client.full_name"></p-avatar>
          <ng-template #noContactPicAgenda>
            <p-avatar styleClass="text-sm w-2rem h-2rem mr-2" [label]="client.full_name | titlecase | shortName"
              shape="circle" [attr.aria-label]="'participant-avatar-' + client.full_name"></p-avatar>
          </ng-template>
        </ng-container>
        <span *ngIf="classObj.class_clients.length > 3" class="text-xs text-600 ml-1"> +{{ classObj.class_clients.length - 3 }} more</span>
      </div>
    </ng-template>

    <ng-template #appointmentDetails let-appointmentObj='data' let-event="event">
      <div class="flex align-items-center" *ngIf="appointmentObj" [ngClass]="appointmentObj.status === 'Cancelled'? 'line-through':''" aria-label="appointment-details">
        <p-avatar *ngIf="appointmentObj.clients.length > 0 && appointmentObj.clients[0].image; else noimageAgenda" [image]="appointmentObj.clients[0].image" styleClass="mr-1 w-2rem h-2rem border-round" [attr.aria-label]="'client-avatar-' + appointmentObj.clients[0].full_name"></p-avatar>
        <ng-template #noimageAgenda>
          <p-avatar styleClass="text-sm w-2rem h-2rem mr-2" [label]="appointmentObj.clients.length > 0 ? (appointmentObj.clients[0].full_name | titlecase | shortName) :'' "
            shape="circle" [attr.aria-label]="'client-avatar-' + appointmentObj.clients[0].full_name"></p-avatar>
        </ng-template>
        <div>
          <div class="text-xs"><strong>{{appointmentObj.type_name_primary_language}}</strong> {{'SCHEDULE.CALENDAR.WITH' | translate }} {{ appointmentObj.clients.length > 0 ? appointmentObj.clients[0].full_name : ''}}</div>
          <div class="text-xxs">{{ event.StartTime | date: 'shortTime'}} - {{ event.EndTime | date: 'shortTime' }} <span *ngIf="appointmentObj.coach_name">({{appointmentObj.coach_name}})</span></div>
        </div>
      </div>
    </ng-template>

    <ng-template #classViewInWeek let-class='data' let-event="event">
      <div class="text-xs flex align-items-center" [ngClass]="class.status === 'Cancelled'? 'line-through':''" aria-label="class-title">
        <strong>{{class.type_name_primary_language}}</strong>
        <i *ngIf="class.is_virtual" class="fa fa-video ml-2 text-900" aria-label="virtual-class-indicator"></i>
      </div>
      <div class="text-xxs" [ngClass]="class.status === 'Cancelled'? 'line-through':''" aria-label="class-details">
        <span *ngIf="!isTrainerView && !isStudioView"> {{'SCHEDULE.CALENDAR.RES' | translate }} <strong>{{class.total_booking}} / {{class.max_capacity}}</strong>
          {{'SCHEDULE.CALENDAR.WAIT' | translate }} <strong>{{class.total_waitlist_booking}} / {{class.max_waitlist}}</strong></span>
        <br *ngIf="!isTrainerView && !isStudioView">{{class.coach_name}} <br> {{class.class_duration}} {{'SCHEDULE.CALENDAR.MIN' | translate }}
      </div>
    </ng-template>

    <ng-template #appointmentViewInWeek let-appointment='data' let-event="event">
      <div *ngIf="!isTrainerView && !isStudioView">
        <p-avatar *ngIf="appointment.clients?.length > 0 && appointment.clients[0].image; else noContactPicWeek" [image]="appointment.clients[0].image" styleClass="mr-1 w-2rem h-2rem border-round" [attr.aria-label]="'client-avatar-' + appointment.clients[0].full_name"></p-avatar>
        <ng-template #noContactPicWeek>
          <p-avatar styleClass="text-sm w-2rem h-2rem mr-2" [label]="appointment.clients?.length > 0 ? (appointment.clients[0].full_name | titlecase | shortName) :''" shape="circle" [attr.aria-label]="'client-avatar-' + appointment.clients[0].full_name"></p-avatar>
        </ng-template>
      </div>
      <div [ngClass]="appointment.status === 'Cancelled'? 'line-through':''" aria-label="appointment-details">
        <div class="text-xs">
          <strong>{{appointment.type_name_primary_language}}</strong>
          <span *ngIf="appointment.clients?.length > 0"> {{'SCHEDULE.CALENDAR.WITH' | translate }} {{ appointment.clients[0].full_name }}</span>
        </div>
        <div class="text-xxs">{{ event.StartTime | date : 'shortTime'}} - {{ event.EndTime | date :'shortTime'}}
        </div>
      </div>
    </ng-template>

  </ejs-schedule>
</div>
